import type { PaymentGridRow } from '@makemydeal/dr-platform-types/typedefs/shared/types/paymentGrid';
import { PAYMENT_GRID_REQUIRED_INFO_COLOR } from '../../constants';

export const roundValue = (value: string) => {
    if (value === '') return null;
    const number = parseFloat(value);
    if (number === 0) return 0;
    return number < 1 ? 1 : Math.round(number);
};

export const hasTermAndDownpayment = (str: string, downPayment: number | null): boolean => {
    return str.includes('term') && (str.includes('downpayment') || downPayment === 0);
};

export const notValidPaymentGridRows = (data: PaymentGridRow[]): boolean => {
    if (!data || data.length === 0) return false;

    const allSubItems = data.flatMap((row) => row.items.map((item) => ({ ...item, downPayment: row.val })));
    return allSubItems.every(
        (item) => !item.isLoading && item.isEmpty && item.id && hasTermAndDownpayment(item.id, item.downPayment)
    );
};

export const disabledStyle = {
    pointerEvents: 'none',
    opacity: 0.5,
    cursor: 'not-allowed'
} as const;

export const hiddenInputMessageStyle = {
    '& .ids-input-message-block': {
        display: 'none'
    }
} as const;

export const requiredInfoStyle = {
    '& .MuiOutlinedInput-root:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
        borderColor: `${PAYMENT_GRID_REQUIRED_INFO_COLOR} !important`
    },
    '& .ids-input-message-block, & .ids-input-message-block-message, & .ids-input-message-block svg': {
        color: `${PAYMENT_GRID_REQUIRED_INFO_COLOR} !important`
    }
} as const;
